import { VStack } from '@chakra-ui/react';

import { ChunkResultItem } from 'pages/telephony/numberBlocks/add/components/ChunkResultItem';

function ChunkResultsList({ items, darkMode, maxH = '400px' }) {
    return (
        <VStack spacing={2} align="stretch" maxH={maxH} overflowY="auto">
            {items.map((item, idx) => (
                <ChunkResultItem key={idx} item={item} darkMode={darkMode} />
            ))}
        </VStack>
    );
}

export default ChunkResultsList;
